export default "__VITE_ASSET__B3lwqa6k__";